import { z } from 'zod';
import { AiCoachContent } from '../../../components/AiCoach/types';
import { sentry } from '../../../lib/sentry';
import { setAiCoachContentData } from './setAiCoachContentData';
import { startAiCoachContentFetch } from './startAiCoachContentFetch';
const GetAiCoachContentResponse = z.object({
  data: AiCoachContent,
  derivedCourseContentId: z.number()
});
const getContentFromResponse = async response => {
  if (!response.ok) {
    sentry.captureError(new Error("Failed to fetch AI Coach content: ".concat(response.statusText)));
  }
  switch (response.status) {
    case 204:
      return null;
    case 200:
      {
        const content = await response.json();
        const validatedResponse = GetAiCoachContentResponse.safeParse(content);
        if (!validatedResponse.success) {
          sentry.captureError(new Error("Failed to validate AI Coach content response: ".concat(JSON.stringify(validatedResponse.error))));
          return null;
        }
        return {
          content: validatedResponse.data.data,
          derivedCourseContentId: validatedResponse.data.derivedCourseContentId
        };
      }
    default:
      sentry.captureError(new Error("Failed to fetch AI Coach content: ".concat(response.statusText)));
      return null;
  }
};
export const getAiCoachContent = _ref => {
  let {
    campusApiUrl,
    exerciseId,
    languageCode
  } = _ref;
  return async (dispatch, getState) => {
    var _data$content, _data$derivedCourseCo;
    const currentState = getState().aiCoachContent;
    const shouldFetchAiCoachContent = currentState.status === 'initial' || currentState.exerciseId !== exerciseId;
    if (!shouldFetchAiCoachContent) {
      return;
    }
    dispatch(startAiCoachContentFetch({
      exerciseId
    }));
    const response = await fetch("".concat(campusApiUrl, "/api/exercise/").concat(exerciseId, "/aiCoachContent"), {
      credentials: 'include',
      headers: {
        'x-dc-lang': languageCode
      }
    });
    const data = await getContentFromResponse(response);
    dispatch(setAiCoachContentData({
      content: (_data$content = data === null || data === void 0 ? void 0 : data.content) !== null && _data$content !== void 0 ? _data$content : null,
      derivedCourseContentId: (_data$derivedCourseCo = data === null || data === void 0 ? void 0 : data.derivedCourseContentId) !== null && _data$derivedCourseCo !== void 0 ? _data$derivedCourseCo : null,
      exerciseId
    }));
  };
};